import gql from 'graphql-tag';

/**
 * @param {string} locale - Язык в котором будет возвращено значение
 * @param {string} currencyCode - Код валюты в которой будет возвращено значение,
 * если не указан то вернет стоимости в нативной валюте трансфера
 * @returns {gql fragment}
 */

const ClassOfVehicleFragment = gql`
  fragment ClassOfVehicleFragment on ClassOfVehicle {
    id
    pax
    baggage
    code
    name(locale: $locale)
  }
`;

export default ClassOfVehicleFragment;



// WEBPACK FOOTER //
// ./src/apolloConst/fragments/ClassOfVehicleFragment.js